import InfoIcon from '@mui/icons-material/Info'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import Box from '@mui/material/Box'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import * as React from 'react'
// import useFilter from 'src/utils/hooks/useFilter'
import { CircularProgress, Stack } from '@mui/material'
import map from 'lodash/map'
import { useNavigate } from 'react-router-dom'
import NoTableDataImg from 'src/assets/images/no-table-data.png'
import EmptyScreen from 'src/components/EmptyScreen/EmptyScreen'
import ExportCSV from 'src/components/ExportCSV'
import { useAuth } from 'src/context/AuthContext'
import { useNewFilterContext } from 'src/context/NewFilterContext/NewFilterContext'
import { DefaultService } from 'src/services/openApi'
import { emptyScreenMessages } from 'src/utils/constants/emptyScreen'
import { measurePerformance } from 'src/utils/functions/performance'
import { comments } from './HostKitchenTable'

interface VirtualBrandProps {
  tab: number
}
const TableTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    padding: 4,
    fontSize: 16
  },
  [`& .${tooltipClasses.arrow}`]: {
    '&::before': {
      backgroundColor: 'white'
    }
  }
}))

const VirtualBrandTable = (props: VirtualBrandProps) => {
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const [tableData, setTableData] = React.useState([])
  const [tableDataLoading, setTableDataLoading] = React.useState(true)
  const { getFilters, selectFiltersFromContext } = useNewFilterContext()
  const { orgConfig } = useAuth()

  const columns: GridColDef[] = [
    {
      field: 'bAndM',
      headerName: 'B&M',
      flex: 1,
      hide: !orgConfig?.filterConfig['b_name']
    },
    {
      field: 'vitualBrand',
      headerName: 'Brand',
      flex: 1,
      hide: !orgConfig?.filterConfig['vb_name']
    },
    {
      field: 'totalSales',
      headerName: 'Total Sales',
      flex: 1,
      renderCell: (params): React.ReactNode => {
        return (
          <>
            <Typography
              variant="body2"
              sx={{ mr: 2 }}>
              ${params.row.totalSales}
            </Typography>
            <TrendingDownIcon sx={{ color: 'red' }} />
          </>
        )
      }
    },
    {
      field: 'percentDelta',
      headerName: '% Delta',
      flex: 1,
      renderCell: (params): React.ReactNode => {
        return (
          <>
            <Typography
              variant="body2"
              sx={{ mr: 2 }}>
              {params.row.percentDelta !== 'N/A' ? params.row.percentDelta + '%' : params.row.percentDelta}
            </Typography>
            {params.row.percentDelta !== 'N/A' && Number(params.row.percentDelta) !== 0 ? (
              params.row.percentDelta < 0 ? (
                <TrendingDownIcon sx={{ color: 'red' }} />
              ) : (
                <TrendingUpIcon sx={{ color: 'green' }} />
              )
            ) : null}
          </>
        )
      },
      renderHeader: (params): React.ReactNode => {
        return (
          <>
            <TableTooltip
              title={
                <Typography
                  variant="body1"
                  textAlign="center">
                  Compares the current Selection date and the pervious date to that.
                </Typography>
              }
              placement="top-start"
              arrow>
              <InfoIcon sx={{ mr: 1, color: 'primary' }} />
            </TableTooltip>
            <Typography variant="body2">% Delta</Typography>
          </>
        )
      }
    },
    {
      field: 'comments',
      headerName: 'Comments',
      flex: 1
    }
  ]

  const headers1 = columns.filter((el) => el.hide !== true).map(({ field, headerName }) => ({ key: field, label: headerName }))

  const columns2: GridColDef[] = [
    {
      field: 'bAndM',
      headerName: 'B&M',
      flex: 1,
      hide: !orgConfig?.filterConfig['b_name']
    },
    {
      field: 'vitualBrand',
      headerName: 'Brand',
      flex: 1,
      hide: !orgConfig?.filterConfig['vb_name']
    },
    {
      field: 'totalSales',
      headerName: 'Total Payout',
      flex: 1,
      renderCell: (params): React.ReactNode => {
        return (
          <>
            <Typography
              variant="body2"
              sx={{ mr: 2 }}>
              ${params.row.totalSales}
            </Typography>
            <TrendingDownIcon sx={{ color: 'red' }} />
          </>
        )
      }
    },
    {
      field: 'percentDelta',
      headerName: '% Delta',
      flex: 1,
      renderCell: (params): React.ReactNode => {
        return (
          <>
            <Typography
              variant="body2"
              sx={{ mr: 2 }}>
              {params.row.percentDelta !== 'N/A' ? params.row.percentDelta + '%' : params.row.percentDelta}
            </Typography>
            {params.row.percentDelta !== 'N/A' && Number(params.row.percentDelta) !== 0 ? (
              params.row.percentDelta < 0 ? (
                <TrendingDownIcon sx={{ color: 'red' }} />
              ) : (
                <TrendingUpIcon sx={{ color: 'green' }} />
              )
            ) : null}
          </>
        )
      },
      renderHeader: (params): React.ReactNode => {
        return (
          <>
            <TableTooltip
              title={
                <Typography
                  variant="body1"
                  textAlign="center">
                  Compares the current Selection date and the pervious date to that.
                </Typography>
              }
              placement="top-start"
              arrow>
              <InfoIcon sx={{ mr: 1, color: 'primary' }} />
            </TableTooltip>
            <Typography variant="body2">% Delta</Typography>
          </>
        )
      }
    },
    {
      field: 'comments',
      headerName: 'Comments',
      flex: 1
    }
  ]

  const headers2 = columns2.filter((el) => el.hide !== true).map(({ field, headerName }) => ({ key: field, label: headerName }))

  const columns3: GridColDef[] = [
    {
      field: 'bAndM',
      headerName: 'B&M',
      flex: 1,
      hide: !orgConfig?.filterConfig['b_name']
    },
    {
      field: 'vitualBrand',
      headerName: 'Brand',
      flex: 1,
      hide: !orgConfig?.filterConfig['vb_name']
    },
    {
      field: 'totalSales',
      headerName: 'Total Orders',
      flex: 1,
      renderCell: (params): React.ReactNode => {
        return (
          <>
            <Typography
              variant="body2"
              sx={{ mr: 2 }}>
              {params.row.totalSales}
            </Typography>
            <TrendingDownIcon sx={{ color: 'red' }} />
          </>
        )
      }
    },
    {
      field: 'percentDelta',
      headerName: '% Delta',
      flex: 1,
      renderCell: (params): React.ReactNode => {
        return (
          <>
            <Typography
              variant="body2"
              sx={{ mr: 2 }}>
              {params.row.percentDelta !== 'N/A' ? params.row.percentDelta + '%' : params.row.percentDelta}
            </Typography>
            {params.row.percentDelta !== 'N/A' && Number(params.row.percentDelta) !== 0 ? (
              params.row.percentDelta < 0 ? (
                <TrendingDownIcon sx={{ color: 'red' }} />
              ) : (
                <TrendingUpIcon sx={{ color: 'green' }} />
              )
            ) : null}
          </>
        )
      },
      renderHeader: (params): React.ReactNode => {
        return (
          <>
            <TableTooltip
              title={
                <Typography
                  variant="body1"
                  textAlign="center">
                  Compares the current Selection date and the pervious date to that.
                </Typography>
              }
              placement="top-start"
              arrow>
              <InfoIcon sx={{ mr: 1, color: 'primary' }} />
            </TableTooltip>
            <Typography variant="body2">% Delta</Typography>
          </>
        )
      }
    },
    {
      field: 'comments',
      headerName: 'Comments',
      width: 340
    }
  ]

  const headers3 = columns3.filter((el) => el.hide !== true).map(({ field, headerName }) => ({ key: field, label: headerName }))

  const procedureNameArray = [
    'data_visualization_metrics.procedure_dashboard__sales_overview__sales__virtual_brand',
    'data_visualization_metrics.procedure_dashboard__sales_overview__ordercount__virtual_brand',
    'data_visualization_metrics.procedure_dashboard__sales_overview__payout__virtual_brand'
  ]
  React.useEffect(() => {
    ;(async () => {
      setTableDataLoading(true)
      try {
        const responseData: any = await measurePerformance(
          async () => {
            return await DefaultService.runProcedureAndGetDataRunQueryPost(
              procedureNameArray[props.tab],
              getFilters(['b_name', 'vb_name', 'chain', 'vb_platform', 'am_name', 'start_date', 'end_date'])
            )
          },
          {
            procedure: procedureNameArray[props.tab],
            email: currentUser.email,
            org: currentUser.org
          }
        )
        if (responseData) {
          setTableData(
            map(responseData, (item, index) => ({
              id: index + 1,
              bAndM: item.b_name,
              vitualBrand: item.vb_name,
              totalSales: props.tab === 0 ? item.total_current_sales : props.tab === 1 ? item.total_current_ordercount : item.total_current_payout,
              percentDelta: item.delta,
              comments: comments(item.vb_platforms_with_zero_sales, item.vb_brands_50_percent_dip, item.vb_platforms_1000_dollar_dip)
            }))
          )
          setTableDataLoading(false)
        }
      } catch (error) {
        setTableDataLoading(false)
        console.log(error)
      }
    })()
  }, [props.tab, currentUser, ...getFilters(['b_name', 'vb_name', 'vb_platform', 'am_name', 'start_date', 'end_date'])])

  const NoDataComponent = () => {
    return (
      <Box sx={{ marginTop: '12px', zIndex: '1', position: 'relative' }}>
        <EmptyScreen
          NoDataImg={NoTableDataImg}
          labels={emptyScreenMessages.emptyTable}
        />
      </Box>
    )
  }

  const goToUrlWithFilters = (b_name, vb_name) => {
    selectFiltersFromContext('b_name', [b_name])
    selectFiltersFromContext('vb_name', [vb_name])
    return `/errors/overview`
  }
  return (
    <Box sx={{ height: 410, width: '95%', m: 'auto' }}>
      {tableDataLoading ? (
        <Box sx={{ p: 3, width: '100%', textAlign: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Stack sx={{ textAlign: 'right' }}>
            <ExportCSV
              csvHeaders={props.tab === 2 ? headers2 : props.tab === 0 ? headers1 : headers3}
              csvData={tableData}
              fileName={'Brand.csv'}
              showIcon={true}
            />
          </Stack>
          <DataGrid
            onRowClick={(data) => navigate(goToUrlWithFilters(data.row.bAndM, data.row.vitualBrand))}
            rows={tableData}
            columns={props.tab === 2 ? columns2 : props.tab === 0 ? columns : columns3}
            pageSize={4}
            disableSelectionOnClick
            rowHeight={70}
            components={tableData && tableData.length === 0 && { NoRowsOverlay: NoDataComponent }}
          />
        </>
      )}
    </Box>
  )
}

export default VirtualBrandTable
